/**
 * @generated SignedSource<<c5cb77c35d42b882c63b6483d41469af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectHeader_psProject$data = {
  readonly name: string | null;
  readonly psProgram: {
    readonly id: string;
    readonly name: string | null;
    readonly color: string | null;
    readonly prefix: string | null;
    readonly isViewerProgramMember: boolean | null;
  } | null;
  readonly " $fragmentType": "ProjectHeader_psProject";
};
export type ProjectHeader_psProject$key = {
  readonly " $data"?: ProjectHeader_psProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectHeader_psProject">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectHeader_psProject",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ProgramType",
      "kind": "LinkedField",
      "name": "psProgram",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "prefix",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isViewerProgramMember",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectServiceProjectType",
  "abstractKey": null
};
})();

(node as any).hash = "94bf9c398a5600571303acdc8d6f62a8";

export default node;
